const TRANSLATION_PLAYBACK_MODES = {
  OFF: "off",
  AUTO: "auto",
  EN_TO_ZH: "en-to-zh",
  ZH_TO_EN: "zh-to-en",
  PREFER_ZH: "prefer-zh",
  PREFER_EN: "prefer-en"
};

const ENGLISH_STATUS_TO_CHINESE = {
  "at home": "在家",
  home: "在家",
  "at school": "在学校",
  school: "在学校",
  "in class": "在上课",
  "on the bus": "在公交车上",
  ready: "准备好了",
  okay: "没事",
  ok: "没事",
  tired: "累了",
  sleepy: "困了",
  happy: "很开心",
  hungry: "饿了",
  here: "在这里"
};

const CHINESE_STATUS_TO_ENGLISH = {
  "在家": "at home",
  "在学校": "at school",
  "在上课": "in class",
  "在公交车上": "on the bus",
  "准备好了": "ready",
  "没事": "okay",
  "累了": "tired",
  "困了": "sleepy",
  "很开心": "happy",
  "饿了": "hungry",
  "在这里": "here"
};

const FAMILY_TO_CHINESE = {
  grandma: "奶奶",
  grandpa: "爷爷",
  mom: "妈妈",
  dad: "爸爸"
};

const FAMILY_TO_ENGLISH = {
  "奶奶": "Grandma",
  "爷爷": "Grandpa",
  "妈妈": "Mom",
  "爸爸": "Dad"
};

const TIME_TO_CHINESE = {
  tomorrow: "明天",
  "this weekend": "这个周末",
  "later tonight": "今晚晚一点",
  tonight: "今晚"
};

const TIME_TO_ENGLISH = {
  "明天": "tomorrow",
  "这个周末": "this weekend",
  "今晚晚一点": "later tonight",
  "今晚": "tonight"
};

const ENGLISH_FRAGMENT_MAP = [
  ["can you see me clearly on wechat now", "你现在在微信视频里能清楚看到我吗"],
  ["can you see me on wechat", "你在微信视频里能看到我吗"],
  ["can you hear me now", "你现在能听到我吗"],
  ["can you hear me", "你能听到我吗"],
  ["please speak slowly", "请说慢一点"],
  ["say it again", "再说一遍"],
  ["look at the screen", "看看屏幕"],
  ["check wechat", "看看微信"],
  ["send me a message", "给我发个消息"],
  ["school project", "学校项目"],
  ["homework", "作业"],
  ["after dinner", "晚饭后"],
  ["this weekend", "这个周末"],
  ["tomorrow", "明天"],
  ["later tonight", "今晚晚一点"],
  ["tonight", "今晚"],
  ["wechat video", "微信视频"],
  ["wechat", "微信"],
  ["drawing", "画"],
  ["picture", "照片"],
  ["book", "书"],
  ["doctor", "医生"],
  ["medicine", "药"],
  ["message", "消息"],
  ["video call", "视频通话"],
  ["grandma", "奶奶"],
  ["grandpa", "爷爷"],
  ["mom", "妈妈"],
  ["dad", "爸爸"],
  ["teacher", "老师"],
  ["wait a moment", "稍等一下"],
  ["wait", "等一下"],
  ["visit you", "去看你"],
  ["call you", "给你打电话"],
  ["show you", "给你看看"],
  ["miss you", "想你"],
  ["love you", "爱你"],
  ["finished", "完成了"]
];

const CHINESE_FRAGMENT_MAP = [
  ["你现在在微信视频里能清楚看到我吗", "Can you see me clearly on WeChat now"],
  ["你现在能听到我吗", "Can you hear me now"],
  ["你能听到我吗", "Can you hear me"],
  ["请说慢一点", "Please speak slowly"],
  ["再说一遍", "Say it again"],
  ["看看屏幕", "look at the screen"],
  ["看看微信", "check WeChat"],
  ["给我发个消息", "send me a message"],
  ["学校项目", "school project"],
  ["作业", "homework"],
  ["晚饭后", "after dinner"],
  ["这个周末", "this weekend"],
  ["明天", "tomorrow"],
  ["今晚晚一点", "later tonight"],
  ["今晚", "tonight"],
  ["微信视频", "WeChat video"],
  ["微信", "WeChat"],
  ["我的画", "my drawing"],
  ["照片", "picture"],
  ["书", "book"],
  ["医生", "doctor"],
  ["药", "medicine"],
  ["消息", "message"],
  ["视频通话", "video call"],
  ["奶奶", "Grandma"],
  ["爷爷", "Grandpa"],
  ["妈妈", "Mom"],
  ["爸爸", "Dad"],
  ["老师", "teacher"],
  ["稍等一下", "wait a moment"],
  ["去看你", "visit you"],
  ["给你打电话", "call you"],
  ["给你看看", "show you"],
  ["想你", "miss you"],
  ["爱你", "love you"],
  ["完成了", "finished"]
];

const TRANSLATION_SAMPLES = [
  ["Can you see me clearly on WeChat now?", "你现在在微信视频里能清楚看到我吗？"],
  ["Can you hear me now?", "你现在能听到我吗？"],
  ["Grandma, I finished my school project today.", "奶奶，我今天完成了学校项目。"],
  ["I finished my homework today.", "我今天完成了作业。"],
  ["We are going to visit you this weekend if the weather is good.", "如果天气好，这个周末我们会去看你。"],
  ["I miss you and I want to show you my drawing.", "我很想你，我想给你看看我的画。"],
  ["We can talk after dinner.", "我们晚饭后可以聊。"],
  ["I will call you later tonight.", "我今晚晚一点给你打电话。"],
  ["Please wait a moment.", "请稍等一下。"],
  ["Please speak slowly.", "请说慢一点。"],
  ["I love you.", "我爱你。"],
  ["Did you eat yet?", "你吃饭了吗？"],
  ["Did you take your medicine?", "你吃药了吗？"],
  ["Are you feeling better today?", "你今天感觉好一点了吗？"],
  ["I am at school right now.", "我现在在学校。"],
  ["I am at home now.", "我现在在家。"],
  ["I am ready now.", "我现在准备好了。"],
  ["I am tired today.", "我今天有点累。"],
  ["I want to show you my homework.", "我想给你看看我的作业。"],
  ["I want to show you my book.", "我想给你看看我的书。"],
  ["Grandma, can you hear me?", "奶奶，你能听到我吗？"],
  ["Grandpa, can you see me?", "爷爷，你能看到我吗？"],
  ["The connection is not stable.", "现在网络不太稳定。"],
  ["Please look at the screen.", "请看看屏幕。"]
];

const ENGLISH_RULES = [
  {
    pattern: /^(hi|hello) (grandma|grandpa|mom|dad)$/i,
    output(match) {
      return `${FAMILY_TO_CHINESE[match[2].toLowerCase()] || "你"}，你好。`;
    }
  },
  {
    pattern: /^good (morning|afternoon|evening|night)$/i,
    output(match) {
      const map = {
        morning: "早上好。",
        afternoon: "下午好。",
        evening: "晚上好。",
        night: "晚安。"
      };
      return map[String(match[1] || "").toLowerCase()] || "";
    }
  },
  {
    pattern: /^(grandma|grandpa|mom|dad),? can you (hear|see) me(?: now)?$/i,
    output(match) {
      const family = FAMILY_TO_CHINESE[match[1].toLowerCase()] || "你";
      const sense = /see/i.test(match[2]) ? "看到" : "听到";
      return `${family}，你现在能${sense}我吗？`;
    }
  },
  {
    pattern: /^can you (hear|see) me(?: now)?$/i,
    output(match) {
      const sense = /see/i.test(match[1]) ? "看到" : "听到";
      return `你现在能${sense}我吗？`;
    }
  },
  {
    pattern: /^please (wait|wait a moment)$/i,
    output: "请稍等一下。"
  },
  {
    pattern: /^please speak slowly$/i,
    output: "请说慢一点。"
  },
  {
    pattern: /^please say it again$/i,
    output: "请再说一遍。"
  },
  {
    pattern: /^please look at the screen$/i,
    output: "请看看屏幕。"
  },
  {
    pattern: /^please check wechat$/i,
    output: "请看看微信。"
  },
  {
    pattern: /^please send me a message$/i,
    output: "请给我发个消息。"
  },
  {
    pattern: /^(grandma|grandpa),? i (finished|completed) (?:my )?(school project|homework)(?: today)?$/i,
    output(match) {
      const family = FAMILY_TO_CHINESE[match[1].toLowerCase()] || "奶奶";
      const task = /homework/i.test(match[3]) ? "作业" : "学校项目";
      return `${family}，我今天完成了${task}。`;
    }
  },
  {
    pattern: /^i (finished|completed) (?:my )?(school project|homework)(?: today)?$/i,
    output(match) {
      const task = /homework/i.test(match[2]) ? "作业" : "学校项目";
      return `我今天完成了${task}。`;
    }
  },
  {
    pattern: /^i want to show you (?:my )?(drawing|picture|homework|book)$/i,
    output(match) {
      const thingMap = {
        drawing: "我的画",
        picture: "照片",
        homework: "我的作业",
        book: "我的书"
      };
      return `我想给你看看${thingMap[String(match[1] || "").toLowerCase()] || "这个"}。`;
    }
  },
  {
    pattern: /^i miss you(?: and i want to show you my drawing)?$/i,
    output(match) {
      if (String(match[0] || "").includes("show you my drawing")) {
        return "我很想你，我想给你看看我的画。";
      }
      return "我很想你。";
    }
  },
  {
    pattern: /^i love you$/i,
    output: "我爱你。"
  },
  {
    pattern: /^we (?:can|should) talk after dinner$/i,
    output: "我们晚饭后可以聊。"
  },
  {
    pattern: /^i will (call|message) you (later tonight|tonight|tomorrow)$/i,
    output(match) {
      const action = /message/i.test(match[1]) ? "给你发消息" : "给你打电话";
      const when = TIME_TO_CHINESE[String(match[2] || "").toLowerCase()] || "稍后";
      return `我${when}${action}。`;
    }
  },
  {
    pattern: /^we (?:will|are going to) (visit|come see) you (tomorrow|this weekend)$/i,
    output(match) {
      const when = TIME_TO_CHINESE[String(match[2] || "").toLowerCase()] || "之后";
      return `${when}我们会去看你。`;
    }
  },
  {
    pattern: /^did you (eat|eat yet|have dinner)(?: yet)?$/i,
    output: "你吃饭了吗？"
  },
  {
    pattern: /^did you take your medicine(?: yet)?$/i,
    output: "你吃药了吗？"
  },
  {
    pattern: /^are you feeling better(?: today)?$/i,
    output: "你今天感觉好一点了吗？"
  },
  {
    pattern: /^the connection is (bad|not stable)$/i,
    output: "现在网络不太稳定。"
  },
  {
    pattern: /^i am ([a-z ]+)$/i,
    output(match) {
      const status = ENGLISH_STATUS_TO_CHINESE[String(match[1] || "").trim().toLowerCase()];
      return status ? `我现在${status}。` : "";
    }
  },
  {
    pattern: /^we are ([a-z ]+)$/i,
    output(match) {
      const status = ENGLISH_STATUS_TO_CHINESE[String(match[1] || "").trim().toLowerCase()];
      return status ? `我们现在${status}。` : "";
    }
  }
];

const CHINESE_RULES = [
  {
    pattern: /^(奶奶|爷爷|妈妈|爸爸)，?你好[。！]?$/,
    output(match) {
      return `${FAMILY_TO_ENGLISH[match[1]] || "Hello"}, hello.`;
    }
  },
  {
    pattern: /^早上好[。！]?$/,
    output: "Good morning."
  },
  {
    pattern: /^下午好[。！]?$/,
    output: "Good afternoon."
  },
  {
    pattern: /^晚上好[。！]?$/,
    output: "Good evening."
  },
  {
    pattern: /^晚安[。！]?$/,
    output: "Good night."
  },
  {
    pattern: /^(奶奶|爷爷|妈妈|爸爸)，?你现在能(听到|看到)我吗[。？]?$/,
    output(match) {
      const family = FAMILY_TO_ENGLISH[match[1]] || "Grandma";
      const sense = match[2] === "看到" ? "see" : "hear";
      return `${family}, can you ${sense} me now?`;
    }
  },
  {
    pattern: /^你现在能(听到|看到)我吗[。？]?$/,
    output(match) {
      const sense = match[1] === "看到" ? "see" : "hear";
      return `Can you ${sense} me now?`;
    }
  },
  {
    pattern: /^请稍等一下[。！]?$/,
    output: "Please wait a moment."
  },
  {
    pattern: /^请说慢一点[。！]?$/,
    output: "Please speak slowly."
  },
  {
    pattern: /^请再说一遍[。！]?$/,
    output: "Please say it again."
  },
  {
    pattern: /^请看看屏幕[。！]?$/,
    output: "Please look at the screen."
  },
  {
    pattern: /^请看看微信[。！]?$/,
    output: "Please check WeChat."
  },
  {
    pattern: /^请给我发个消息[。！]?$/,
    output: "Please send me a message."
  },
  {
    pattern: /^(奶奶|爷爷)，?我今天完成了(学校项目|作业)[。！]?$/,
    output(match) {
      const family = FAMILY_TO_ENGLISH[match[1]] || "Grandma";
      const task = match[2] === "作业" ? "homework" : "school project";
      return `${family}, I finished my ${task} today.`;
    }
  },
  {
    pattern: /^我今天完成了(学校项目|作业)[。！]?$/,
    output(match) {
      const task = match[1] === "作业" ? "homework" : "school project";
      return `I finished my ${task} today.`;
    }
  },
  {
    pattern: /^我想给你看看(我的画|照片|我的作业|我的书)[。！]?$/,
    output(match) {
      const thingMap = {
        "我的画": "my drawing",
        "照片": "a picture",
        "我的作业": "my homework",
        "我的书": "my book"
      };
      return `I want to show you ${thingMap[match[1]] || "this"}.`;
    }
  },
  {
    pattern: /^我很想你(?:，我想给你看看我的画)?[。！]?$/,
    output(match) {
      if (String(match[0] || "").includes("我的画")) {
        return "I miss you and I want to show you my drawing.";
      }
      return "I miss you.";
    }
  },
  {
    pattern: /^我爱你[。！]?$/,
    output: "I love you."
  },
  {
    pattern: /^我们晚饭后可以聊[。！]?$/,
    output: "We can talk after dinner."
  },
  {
    pattern: /^我(明天|今晚晚一点|今晚)给你(打电话|发消息)[。！]?$/,
    output(match) {
      const when = TIME_TO_ENGLISH[match[1]] || "later";
      const action = match[2] === "发消息" ? "message" : "call";
      return `I will ${action} you ${when}.`;
    }
  },
  {
    pattern: /^(明天|这个周末)我们会去看你[。！]?$/,
    output(match) {
      const when = TIME_TO_ENGLISH[match[1]] || "later";
      return `We will visit you ${when}.`;
    }
  },
  {
    pattern: /^你吃饭了吗[。？]?$/,
    output: "Did you eat yet?"
  },
  {
    pattern: /^你吃药了吗[。？]?$/,
    output: "Did you take your medicine?"
  },
  {
    pattern: /^你今天感觉好一点了吗[。？]?$/,
    output: "Are you feeling better today?"
  },
  {
    pattern: /^现在网络不太稳定[。！]?$/,
    output: "The connection is not stable."
  },
  {
    pattern: /^我现在(在家|在学校|在上课|在公交车上|准备好了|没事|累了|困了|很开心|饿了|在这里)[。！]?$/,
    output(match) {
      const status = CHINESE_STATUS_TO_ENGLISH[match[1]];
      return status ? `I am ${status}.` : "";
    }
  },
  {
    pattern: /^我们现在(在家|在学校|准备好了|在这里)[。！]?$/,
    output(match) {
      const status = CHINESE_STATUS_TO_ENGLISH[match[1]];
      return status ? `We are ${status}.` : "";
    }
  }
];

const translationCache = new Map();
const remoteTranslationPromises = new Map();

function normalizeTranslationPlaybackMode(value) {
  const normalized = String(value || "").trim().toLowerCase();

  if (
    normalized === TRANSLATION_PLAYBACK_MODES.AUTO ||
    normalized === TRANSLATION_PLAYBACK_MODES.EN_TO_ZH ||
    normalized === TRANSLATION_PLAYBACK_MODES.ZH_TO_EN ||
    normalized === TRANSLATION_PLAYBACK_MODES.PREFER_ZH ||
    normalized === TRANSLATION_PLAYBACK_MODES.PREFER_EN
  ) {
    return normalized;
  }

  return TRANSLATION_PLAYBACK_MODES.OFF;
}

function getLanguageBase(language) {
  const normalized = String(language || "").trim().toLowerCase();

  if (normalized.startsWith("fr")) {
    return "fr";
  }

  if (normalized.startsWith("ja")) {
    return "ja";
  }

  if (
    normalized.startsWith("zh") ||
    normalized.startsWith("cmn") ||
    normalized.startsWith("yue")
  ) {
    return "zh";
  }

  if (normalized.startsWith("en")) {
    return "en";
  }

  return "other";
}

function getLanguageTag(baseLanguage) {
  if (baseLanguage === "fr") {
    return "fr-FR";
  }

  if (baseLanguage === "zh") {
    return "zh-CN";
  }

  if (baseLanguage === "ja") {
    return "ja-JP";
  }

  return "en-US";
}

function getTargetLanguageBase(sourceLanguage, mode) {
  if (mode === TRANSLATION_PLAYBACK_MODES.OFF) {
    return "";
  }

  if (mode === TRANSLATION_PLAYBACK_MODES.AUTO) {
    if (sourceLanguage === "en") {
      return "zh";
    }

    if (sourceLanguage === "fr") {
      return "zh";
    }

    if (sourceLanguage === "zh") {
      return "en";
    }

    if (sourceLanguage === "ja") {
      return "zh";
    }

    return "";
  }

  if (mode === TRANSLATION_PLAYBACK_MODES.EN_TO_ZH) {
    return sourceLanguage === "en" ? "zh" : "";
  }

  if (mode === TRANSLATION_PLAYBACK_MODES.ZH_TO_EN) {
    return sourceLanguage === "zh" ? "en" : "";
  }

  if (mode === TRANSLATION_PLAYBACK_MODES.PREFER_ZH) {
    return sourceLanguage === "en" || sourceLanguage === "fr" || sourceLanguage === "ja"
      ? "zh"
      : "";
  }

  if (mode === TRANSLATION_PLAYBACK_MODES.PREFER_EN) {
    return sourceLanguage === "zh" ? "en" : "";
  }

  return "";
}

function normalizeEnglish(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[.!?]+$/g, "")
    .replace(/\s+/g, " ");
}

function normalizeChinese(value) {
  return String(value || "")
    .trim()
    .replace(/[。！？；：,.!?;:\s]+/g, "");
}

function punctuateChinese(value) {
  const trimmed = String(value || "")
    .replace(/\s+/g, "")
    .replace(/[，,]{2,}/g, "，")
    .replace(/[。]{2,}/g, "。")
    .trim();

  if (!trimmed) {
    return "";
  }

  return /[。！？]$/.test(trimmed) ? trimmed : `${trimmed}。`;
}

function punctuateEnglish(value) {
  const trimmed = String(value || "")
    .replace(/\s+/g, " ")
    .trim();

  if (!trimmed) {
    return "";
  }

  const capitalized = trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
  return /[.!?]$/.test(capitalized) ? capitalized : `${capitalized}.`;
}

function splitEnglishSentences(text) {
  return String(text || "")
    .split(/(?<=[.!?])\s+|\n+/)
    .map((segment) => segment.trim())
    .filter(Boolean);
}

function splitChineseSentences(text) {
  return String(text || "")
    .split(/[。！？\n]+/)
    .map((segment) => segment.replace(/\s+/g, "").trim())
    .filter(Boolean);
}

function splitLongSentenceBySoftBoundaries(segment, boundaries, joiner, maxLength) {
  const escapedBoundaries = boundaries.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const parts = String(segment || "")
    .split(new RegExp(`(?<=[${escapedBoundaries}])`))
    .map((part) => part.trim())
    .filter(Boolean);

  if (!parts.length) {
    return [String(segment || "").trim()].filter(Boolean);
  }

  const grouped = [];
  let current = "";

  parts.forEach((part) => {
    if (!current) {
      current = part;
      return;
    }

    const candidate = `${current}${joiner}${part}`.trim();

    if (candidate.length > maxLength) {
      grouped.push(current);
      current = part;
      return;
    }

    current = candidate;
  });

  if (current) {
    grouped.push(current);
  }

  return grouped;
}

function prepareEnglishTranslationUnits(text) {
  return splitEnglishSentences(text).flatMap((sentence) => {
    if (sentence.length <= 140) {
      return [sentence];
    }

    return splitLongSentenceBySoftBoundaries(sentence, ",;:-", " ", 140);
  });
}

function prepareChineseTranslationUnits(text) {
  return splitChineseSentences(text).flatMap((sentence) => {
    if (sentence.length <= 70) {
      return [sentence];
    }

    return splitLongSentenceBySoftBoundaries(sentence, "，；：、", "", 70);
  });
}

function applyRuleSet(text, rules) {
  const normalizedText = String(text || "").trim();

  for (const rule of rules) {
    const match = normalizedText.match(rule.pattern);

    if (match) {
      return typeof rule.output === "function" ? rule.output(match) : rule.output;
    }
  }

  return "";
}

function replaceEnglishFragments(text) {
  let translated = String(text || "").trim().toLowerCase();

  if (!translated) {
    return "";
  }

  ENGLISH_FRAGMENT_MAP.forEach(([from, to]) => {
    const escaped = from.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/\s+/g, "\\s+");
    const pattern = new RegExp(`\\b${escaped}\\b`, "gi");
    translated = translated.replace(pattern, to);
  });

  return punctuateChinese(translated);
}

function replaceChineseFragments(text) {
  let translated = String(text || "").trim();

  if (!translated) {
    return "";
  }

  CHINESE_FRAGMENT_MAP.forEach(([from, to]) => {
    const pattern = new RegExp(from.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g");
    translated = translated.replace(pattern, to);
  });

  return punctuateEnglish(translated);
}

function countChineseCharacters(text) {
  return (String(text || "").match(/[\u4e00-\u9fff]/g) || []).length;
}

function countLatinWords(text) {
  return (String(text || "").match(/[A-Za-z]+/g) || []).length;
}

function isMeaningfulChineseTranslation(sourceText, translatedText) {
  const sourceWords = countLatinWords(sourceText);
  const translatedChinese = countChineseCharacters(translatedText);
  const remainingLatin = countLatinWords(translatedText);

  return translatedChinese >= Math.max(4, Math.ceil(sourceWords * 0.45)) && remainingLatin <= 2;
}

function isMeaningfulEnglishTranslation(sourceText, translatedText) {
  const sourceChinese = countChineseCharacters(sourceText);
  const translatedWords = countLatinWords(translatedText);
  const remainingChinese = countChineseCharacters(translatedText);

  return translatedWords >= Math.max(2, Math.ceil(sourceChinese / 4)) && remainingChinese <= 1;
}

function findSampleByEnglish(englishText) {
  const normalized = normalizeEnglish(englishText);
  const sample = TRANSLATION_SAMPLES.find(
    ([english]) => normalizeEnglish(english) === normalized
  );
  return sample ? { englishText: sample[0], chineseText: sample[1] } : null;
}

function findSampleByChinese(chineseText) {
  const normalized = normalizeChinese(chineseText);
  const sample = TRANSLATION_SAMPLES.find(
    ([, chinese]) => normalizeChinese(chinese) === normalized
  );
  return sample ? { englishText: sample[0], chineseText: sample[1] } : null;
}

function translateEnglishSentence(sentence) {
  const normalized = String(sentence || "").trim();

  if (!normalized) {
    return "";
  }

  const sample = findSampleByEnglish(normalized);
  if (sample) {
    return sample.chineseText;
  }

  const ruleMatch = applyRuleSet(normalized, ENGLISH_RULES);
  if (ruleMatch) {
    return ruleMatch;
  }

  const fallback = replaceEnglishFragments(normalized);
  return isMeaningfulChineseTranslation(normalized, fallback) ? fallback : "";
}

function translateChineseSentence(sentence) {
  const normalized = String(sentence || "").trim();

  if (!normalized) {
    return "";
  }

  const sample = findSampleByChinese(normalized);
  if (sample) {
    return sample.englishText;
  }

  const ruleMatch = applyRuleSet(normalized, CHINESE_RULES);
  if (ruleMatch) {
    return ruleMatch;
  }

  const fallback = replaceChineseFragments(normalized);
  return isMeaningfulEnglishTranslation(normalized, fallback) ? fallback : "";
}

function buildFallbackChinese(text) {
  const sentences = prepareEnglishTranslationUnits(text);

  if (!sentences.length) {
    return "";
  }

  return sentences
    .map((sentence) => translateEnglishSentence(sentence))
    .filter(Boolean)
    .map((sentence) => punctuateChinese(sentence))
    .join("");
}

function buildFallbackEnglish(text) {
  const sentences = prepareChineseTranslationUnits(text);

  if (!sentences.length) {
    return "";
  }

  return sentences
    .map((sentence) => translateChineseSentence(sentence))
    .filter(Boolean)
    .map((sentence) => punctuateEnglish(sentence))
    .join(" ");
}

function getCacheKey(text, sourceLanguage, targetLanguage) {
  return `${sourceLanguage}::${targetLanguage}::${String(text || "").trim()}`;
}

function translateText(text, sourceLanguage, targetLanguage) {
  if (!String(text || "").trim()) {
    return "";
  }

  if (sourceLanguage === "en" && targetLanguage === "zh") {
    return buildFallbackChinese(text);
  }

  if (sourceLanguage === "zh" && targetLanguage === "en") {
    return buildFallbackEnglish(text);
  }

  return "";
}

function getCachedTranslation(text, sourceLanguage, targetLanguage) {
  const cacheKey = getCacheKey(text, sourceLanguage, targetLanguage);

  if (translationCache.has(cacheKey)) {
    return translationCache.get(cacheKey);
  }

  const translatedText = translateText(text, sourceLanguage, targetLanguage);
  const entry = {
    translatedText,
    sourceLanguage: getLanguageTag(sourceLanguage),
    targetLanguage: getLanguageTag(targetLanguage),
    didTranslate: Boolean(translatedText)
  };

  translationCache.set(cacheKey, entry);
  return entry;
}

async function requestRemoteTranslation(text, sourceLanguage, targetLanguage) {
  const response = await fetch("/api/echo/translate-playback", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      text,
      sourceLanguage,
      targetLanguage
    })
  });

  if (!response.ok) {
    throw new Error("Remote translation request failed.");
  }

  const payload = await response.json();
  return {
    translatedText: String(payload?.translatedText || "").trim(),
    sourceLanguage: getLanguageTag(sourceLanguage),
    targetLanguage: getLanguageTag(targetLanguage),
    didTranslate: Boolean(payload?.didTranslate && String(payload?.translatedText || "").trim())
  };
}

function getBestCachedTranslation(text, sourceLanguage, targetLanguage) {
  return getCachedTranslation(text, sourceLanguage, targetLanguage);
}

function mapOffsetAcrossTexts(fromText, toText, offsetChars) {
  const sourceLength = String(fromText || "").length;
  const targetLength = String(toText || "").length;
  const safeOffset = Math.max(0, Math.min(Number(offsetChars) || 0, sourceLength));

  if (!sourceLength || !targetLength || sourceLength === targetLength) {
    return Math.max(0, Math.min(safeOffset, targetLength));
  }

  if (safeOffset <= 0) {
    return 0;
  }

  if (safeOffset >= sourceLength) {
    return targetLength;
  }

  return Math.max(
    0,
    Math.min(targetLength, Math.round((safeOffset / sourceLength) * targetLength))
  );
}

function getTranslatedBlockForPlayback(block, mode) {
  const normalizedMode = normalizeTranslationPlaybackMode(mode);
  const sourceText = String(block?.text || "");
  const sourceLanguageBase = getLanguageBase(block?.language);
  const targetLanguageBase = getTargetLanguageBase(sourceLanguageBase, normalizedMode);

  if (!sourceText.trim() || !targetLanguageBase) {
    return {
      text: sourceText,
      language: String(block?.language || "en-US"),
      sourceLanguage: String(block?.language || "en-US"),
      targetLanguage: String(block?.language || "en-US"),
      didTranslate: false
    };
  }

  const entry = getBestCachedTranslation(sourceText, sourceLanguageBase, targetLanguageBase);

  if (!entry.didTranslate || !entry.translatedText) {
    return {
      text: sourceText,
      language: String(block?.language || "en-US"),
      sourceLanguage: String(block?.language || "en-US"),
      targetLanguage: String(block?.language || "en-US"),
      didTranslate: false
    };
  }

  return {
    text: entry.translatedText,
    language: entry.targetLanguage,
    sourceLanguage: entry.sourceLanguage,
    targetLanguage: entry.targetLanguage,
    didTranslate: true
  };
}

function getTranslationStatusForBlock(block, mode) {
  const normalizedMode = normalizeTranslationPlaybackMode(mode);
  const sourceText = String(block?.text || "");
  const sourceLanguageBase = getLanguageBase(block?.language);
  const targetLanguageBase = getTargetLanguageBase(sourceLanguageBase, normalizedMode);

  if (!sourceText.trim() || !targetLanguageBase) {
    return {
      translatedText: "",
      sourceLanguage: String(block?.language || "en-US"),
      targetLanguage: String(block?.language || "en-US"),
      didTranslate: false,
      pendingRemote: false
    };
  }

  const cacheKey = getCacheKey(sourceText, sourceLanguageBase, targetLanguageBase);
  const entry = getBestCachedTranslation(sourceText, sourceLanguageBase, targetLanguageBase);
  const pendingValue = remoteTranslationPromises.get(cacheKey);

  return {
    translatedText: entry.translatedText,
    sourceLanguage: entry.sourceLanguage || getLanguageTag(sourceLanguageBase),
    targetLanguage: entry.targetLanguage || getLanguageTag(targetLanguageBase),
    didTranslate: Boolean(entry.didTranslate && entry.translatedText),
    pendingRemote: Boolean(pendingValue && pendingValue !== "ready")
  };
}

function buildPlaybackBlocks(blocks, mode) {
  return Array.isArray(blocks)
    ? blocks.map((block, index) => {
        const translated = getTranslatedBlockForPlayback(block, mode);

        return {
          ...block,
          index: Number.isInteger(block?.index) ? block.index : index,
          text: translated.text,
          language: translated.language
        };
      })
    : [];
}

async function warmTranslationCache(blocks, mode, options = {}) {
  const normalizedMode = normalizeTranslationPlaybackMode(mode);
  const shouldPreferRemote = Boolean(options.preferRemote);
  const shouldAwaitRemote = Boolean(options.awaitRemote);
  const onRemoteUpdate =
    typeof options.onRemoteUpdate === "function" ? options.onRemoteUpdate : null;
  const pendingPromises = [];
  let didUpdateCache = false;

  if (normalizedMode === TRANSLATION_PLAYBACK_MODES.OFF) {
    return false;
  }

  (Array.isArray(blocks) ? blocks : []).forEach((block) => {
    const sourceText = String(block?.text || "");
    const sourceLanguageBase = getLanguageBase(block?.language);
    const targetLanguageBase = getTargetLanguageBase(sourceLanguageBase, normalizedMode);

    if (!sourceText.trim() || !targetLanguageBase) {
      return;
    }

    const cacheKey = getCacheKey(sourceText, sourceLanguageBase, targetLanguageBase);
    const localEntry = getCachedTranslation(sourceText, sourceLanguageBase, targetLanguageBase);

    if (
      !shouldPreferRemote ||
      (localEntry.didTranslate && remoteTranslationPromises.get(cacheKey) === "ready")
    ) {
      return;
    }

    if (remoteTranslationPromises.has(cacheKey)) {
      const pending = remoteTranslationPromises.get(cacheKey);
      if (pending && typeof pending.then === "function") {
        pendingPromises.push(pending);
      }
      return;
    }

    const remotePromise = requestRemoteTranslation(
      sourceText,
      sourceLanguageBase,
      targetLanguageBase
    )
      .then((entry) => {
        remoteTranslationPromises.set(cacheKey, "ready");
        if (entry.didTranslate && entry.translatedText) {
          const existing = translationCache.get(cacheKey);
          if (!existing || existing.translatedText !== entry.translatedText) {
            translationCache.set(cacheKey, entry);
            didUpdateCache = true;
            onRemoteUpdate?.();
          }
        }
        return entry;
      })
      .catch(() => {
        remoteTranslationPromises.delete(cacheKey);
        return null;
      });

    remoteTranslationPromises.set(cacheKey, remotePromise);
    onRemoteUpdate?.();
    pendingPromises.push(remotePromise);
  });

  if (shouldAwaitRemote && pendingPromises.length) {
    await Promise.allSettled(pendingPromises);
  }

  return didUpdateCache;
}

export {
  TRANSLATION_PLAYBACK_MODES,
  buildPlaybackBlocks,
  getTranslationStatusForBlock,
  getTranslatedBlockForPlayback,
  mapOffsetAcrossTexts,
  normalizeTranslationPlaybackMode,
  warmTranslationCache
};
